// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__22xxu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3JEKW"};